const compact = new Intl.NumberFormat("fr-FR", { notation: "compact", maximumFractionDigits: 1 });
const decimal = new Intl.NumberFormat("fr-FR", { maximumFractionDigits: 2 });

const formatValue = (indicator) => {
  if (indicator?.value == null || indicator?.value === "") return "—";
  const value = Number(indicator?.value);
  if (!Number.isFinite(value)) return "—";
  if (indicator.key === "exchange_rate_eur") {
    return indicator.unit === "EUR" ? "1 EUR" : `1 EUR = ${decimal.format(value)} ${indicator.unit}`;
  }
  if (indicator.unit === "%") return `${decimal.format(value)} %`;
  if (indicator.unit === "USD") return `${compact.format(value)} $US`;
  if (indicator.unit === "persons") return compact.format(value);
  return `${decimal.format(value)} ${indicator.unit || ""}`.trim();
};

export const formatEconomicIndicators = (payload) => {
  if (!payload?.available || !Array.isArray(payload.indicators)) return [];
  return payload.indicators.map((indicator) => {
    const delta = Number(indicator.delta_percent);
    const hasDelta = indicator.delta_percent != null && indicator.delta_percent !== "" && Number.isFinite(delta);
    const inverse = indicator.key === "inflation" || indicator.key === "unemployment";
    return {
      key: indicator.key,
      label: indicator.label,
      value: formatValue(indicator),
      delta: hasDelta ? `${delta > 0 ? "+" : ""}${decimal.format(delta)} %` : "Évolution indisponible",
      positive: hasDelta ? (inverse ? delta <= 0 : delta >= 0) : true,
      trend: (indicator.trend || []).map((point) => Number(point.value)).filter(Number.isFinite),
      period: indicator.period,
      source: indicator.source,
    };
  });
};

export const economicProviders = (payload) => Array.from(new Set(
  (payload?.indicators || []).map((indicator) => indicator?.source?.provider).filter(Boolean)
));
